import { render, staticRenderFns } from "./forgetPwd-inner-bv.vue?vue&type=template&id=4db5d082"
import script from "./forgetPwd-inner-bv.vue?vue&type=script&lang=js"
export * from "./forgetPwd-inner-bv.vue?vue&type=script&lang=js"
import style0 from "./forgetPwd-inner-bv.vue?vue&type=style&index=0&id=4db5d082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports